import * as R from 'ramda';
import React, { Component } from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";

import CustomizedParameters from "./CustomizedParameters";
import NoteView from "./Note";

const styles = {
  container: { minWidth: "35em", marginLeft: "1em", marginBottom: "1em" },
  rightAlignedCell: { textAlign: "center" },
  boldCell: { fontWeight: "bold" },
  column: {
    display: "flex",
    "flex-direction": "column"
  }
};

class DevicesAside extends Component {
  render() {
    const { classes, record } = this.props;
    if (!record) {
      return null;
    }
    const { devices } = record;
    const platform = R.pathOr('iOS', ['platformInfo', 'platform'], record);
    const isAndroid = platform === 'android';
    const fieldName = isAndroid ? 'mac' : 'uuid';

    return (
      <div className={classes.column}>
        <Paper className={classes.container}>
          <div>
            <Typography
              variant="subheading"
              className={classes.rightAlignedCell}
            >
              Devices
            </Typography>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{fieldName.toUpperCase()}</TableCell>
                <TableCell>Serial</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {devices.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{R.pathOr('n/a', [fieldName], item)}</TableCell>
                  <TableCell>{item.serialNumber}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
        <CustomizedParameters record={record} />
        <NoteView record={record} {...this.props} />
      </div>
    );
  }
}

export default withStyles(styles)(DevicesAside);


class TheragunDevicesAside_ extends Component {
  render() {
    const { classes, record } = this.props;
    if (!record) {
      return null;
    }
    const { devices } = record;
    const platform = R.pathOr('iOS', ['platformInfo', 'platform'], record);
    const isAndroid = platform === 'android';
    const fieldName = isAndroid ? 'mac' : 'uuid';

    return (
        <div className={classes.column}>
          <Paper className={classes.container}>
            <div>
              <Typography
                  variant="subheading"
                  className={classes.rightAlignedCell}
              >
                Devices
              </Typography>
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{fieldName.toUpperCase()}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devices.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{R.pathOr('n/a', [fieldName], item)}</TableCell>
                    </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
          <CustomizedParameters record={record} />
          <NoteView record={record} {...this.props} />
        </div>
    );
  }
}

export const TheragunDevicesAside = withStyles(styles)(TheragunDevicesAside_);
